import * as React from "react";

import { ILeanSvgIcon } from "../ILeanSvgIcon";
// tslint:disable
export const yammer_praise_trophy: React.FunctionComponent<ILeanSvgIcon> = ({ ...rest }) => {
  return (
    <svg viewBox="0 0 150 150" id="yk-svg-praise-trophy" {...rest}>
      <title>praise-trophy</title>
      <ellipse
        transform="rotate(-88.267 74.997 75.003) scale(.99996)"
        fill="#9AC3FF"
        cx="75"
        cy="75"
        rx="75"
        ry="75"
      ></ellipse>
      <g fill="#F8AE41">
        <path d="M45.6 25.1h61.5s3.2 62.6-30.8 62.6-30.7-62.6-30.7-62.6z"></path>
        <path d="M58.7 106.4s17.7-19.7 17.7-30.2c0 10.5 17.6 30.2 17.6 30.2H58.7zm39.7-35.7v-4.9c8.4 0 14.8-4.6 19-13.7 2.1-4.5 3.1-9.1 3.6-11.8h-15.6v-4.9h18.5c.7 0 1.3.3 1.8.8s.7 1.2.6 1.9c-1 11.3-8.1 32.6-27.9 32.6zm-44.3 0v-4.9c-8.4 0-14.8-4.6-19-13.7C33 47.6 32 43 31.5 40.3H47v-4.9H28.6c-.7 0-1.3.3-1.8.8s-.7 1.2-.6 1.9c.9 11.3 8 32.6 27.9 32.6z"></path>
      </g>
      <path
        fill="#FFE7B8"
        d="M76.3 62.7L66 68.1l2-11.5-8.3-8.1 11.5-1.7 5.1-10.4 5.2 10.4L93 48.5l-8.4 8.1 2 11.5z"
      ></path>
      <path
        fill="#646D7A"
        d="M102.7 120.8c-.2 0-.3-.1-.3-.3v-8.2c0-3.3-2.7-5.9-5.9-5.9H57.2c-3.3 0-5.9 2.7-5.9 5.9v8.2c0 .2-.1.3-.3.3h-1c-2.5 0-4.6 2-4.6 4.6v6.3c0 .2.1.3.3.3h61.1c.2 0 .3-.1.3-.3v-6.3c.1-2.5-1.9-4.6-4.4-4.6z"
      ></path>
    </svg>
  );
};
